var map = {
	"./floating-labels": 923,
	"./floating-labels.js": 923,
	"./gradient-overlay": 276,
	"./gradient-overlay.js": 276,
	"./header": 968,
	"./header.js": 968,
	"./play-icon-decorator": 233,
	"./play-icon-decorator.js": 233,
	"./spotlight-card-list": 353,
	"./spotlight-card-list.js": 353,
	"./sticky-column": 913,
	"./sticky-column.js": 913,
	"./vc-single-image": 471,
	"./vc-single-image.js": 471
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 296;